import { render, staticRenderFns } from "./ShinySvgGradient.vue?vue&type=template&id=44234816&scoped=true&"
import script from "./ShinySvgGradient.vue?vue&type=script&lang=js&"
export * from "./ShinySvgGradient.vue?vue&type=script&lang=js&"
import style0 from "./ShinySvgGradient.vue?vue&type=style&index=0&id=44234816&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44234816",
  null
  
)

export default component.exports